// extracted by mini-css-extract-plugin
module.exports = {"BackLink":"BackLink_BackLink__8K6zk","BackLink_arrow":"BackLink_BackLink_arrow__O8dMg"};